var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ3Command(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59 13H17a4 4 0 00-4 4v42a4 4 0 004 4h42a4 4 0 004-4V17a4 4 0 00-4-4zm0 46H17V17h42v42zm-21-4.19A16.81 16.81 0 1021.19 38 16.8 16.8 0 0038 54.81zm-2-25.93h4v18.24h-4V28.88z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J3_Command.9c18536f.svg";
export { SvgJ3Command as ReactComponent };